(() => {
  const desktop = matchMedia('(min-width: 990px)');
  const style = document.createElement('style');
  style.textContent = `
    @media (min-width:990px) {
      html.adwoa-shop-interface-active #main-collection-filters { display:none!important; }
      .adwoa-filter-dropdown { position:fixed; z-index:2147481600; width:max-content; max-width:calc(100vw - 40px); max-height:calc(100vh - 100px); overflow-y:auto; padding:8px 0 16px; background:transparent!important; border:0; box-shadow:none; pointer-events:auto; color:#000; }
      .adwoa-filter-dropdown[hidden] { display:none!important; }
      .adwoa-filter-dropdown__inner,.adwoa-filter-dropdown__group,.adwoa-filter-dropdown__options { display:flex; flex-direction:column; align-items:flex-start; }
      .adwoa-filter-dropdown__inner { gap:20px; margin:0; }
      .adwoa-filter-dropdown__group { gap:8px; }
      .adwoa-filter-dropdown__options { gap:8px; }
      .adwoa-filter-dropdown button,.adwoa-filter-dropdown label,.adwoa-filter-dropdown__heading { font:inherit; letter-spacing:inherit; text-transform:uppercase; text-decoration:none!important; }
      .adwoa-filter-dropdown__sort,.adwoa-filter-dropdown__clear,.adwoa-filter-dropdown__option { display:block; position:relative; width:fit-content; margin:0; padding:0!important; border:0; background:transparent; color:inherit; white-space:nowrap; cursor:pointer; }
      .adwoa-filter-dropdown__sort,.adwoa-filter-dropdown__option span,.adwoa-filter-dropdown__clear { opacity:.5; }
      .adwoa-filter-dropdown__sort.is-selected,.adwoa-filter-dropdown__sort:hover,.adwoa-filter-dropdown__sort:focus-visible,.adwoa-filter-dropdown__option input:checked + span,.adwoa-filter-dropdown__option:hover span,.adwoa-filter-dropdown__option input:focus-visible + span,.adwoa-filter-dropdown__clear:hover { opacity:1; }
      .adwoa-filter-dropdown__option input { position:absolute; width:1px; height:1px; opacity:0; }
      .adwoa-filter-dropdown__option.is-disabled { opacity:.4; cursor:default; }
      .adwoa-filter-dropdown__option input:focus-visible + span { outline:1px solid; outline-offset:3px; }
      [data-adwoa-filter][aria-expanded="true"] { opacity:.5; }
    }
    @media (max-width:989px) { .adwoa-filter-dropdown { display:none!important; } }
  `;
  document.head.append(style);
  let panel;
  let trigger;
  const close = (focus = false) => {
    if (panel) panel.hidden = true;
    trigger?.setAttribute('aria-expanded', 'false');
    if (focus) trigger?.focus();
  };
  const position = () => {
    if (!panel || panel.hidden || !trigger) return;
    const rect = trigger.getBoundingClientRect();
    panel.style.left = `${Math.min(rect.left, innerWidth - panel.offsetWidth - 20)}px`;
    panel.style.top = `${rect.bottom + 8}px`;
  };
  const go = params => {
    params.delete('page');
    const query = params.toString();
    location.assign(`${location.pathname}${query ? '?' + query : ''}`);
  };
  const build = () => {
    const source = document.querySelector('#FacetFiltersFormMobile') || document.querySelector('#FacetFiltersForm');
    const form = document.createElement('form');
    form.className = 'adwoa-filter-dropdown__inner';
    const params = new URLSearchParams(location.search);
    const group = title => {
      const section = document.createElement('div');
      section.className = 'adwoa-filter-dropdown__group';
      const heading = document.createElement('span');
      heading.className = 'adwoa-filter-dropdown__heading';
      heading.textContent = title;
      const options = document.createElement('div');
      options.className = 'adwoa-filter-dropdown__options';
      section.append(heading, options);
      form.append(section);
      return options;
    };
    const sort = group('SORT');
    const currentSort = params.get('sort_by') || source?.querySelector('[name="sort_by"]')?.value || 'manual';
    [['RECOMMENDED','manual'],['NEWEST','created-descending'],['PRICE: LOW TO HIGH','price-ascending'],['PRICE: HIGH TO LOW','price-descending']].forEach(([label, value]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'adwoa-filter-dropdown__sort';
      button.textContent = label;
      button.classList.toggle('is-selected', currentSort === value);
      button.setAttribute('aria-pressed', String(currentSort === value));
      button.addEventListener('click', () => {
        const next = new URLSearchParams(location.search);
        next.set('sort_by', value);
        go(next);
      });
      sort.append(button);
    });
    const managed = new Set();
    const groups = source ? [...source.querySelectorAll('.js-filter')] : [];
    ['SIZE', 'AVAILABILITY'].forEach(title => {
      const native = groups.find(element => (element.querySelector('.mobile-facets__summary span,.facets__summary span,summary span')?.textContent || '').trim().toUpperCase().includes(title));
      if (!native) return;
      let inputs = [...native.querySelectorAll('input[name^="filter."]')].filter(input => ['checkbox','radio'].includes(input.type));
      if (title === 'AVAILABILITY') inputs = inputs.filter(input => input.value === '1');
      if (!inputs.length) return;
      const options = group(title);
      inputs.forEach(original => {
        managed.add(original.name);
        const label = document.createElement('label');
        label.className = 'adwoa-filter-dropdown__option';
        label.classList.toggle('is-disabled', original.disabled);
        const input = document.createElement('input');
        input.type = original.type;
        input.name = original.name;
        input.value = original.value;
        input.checked = original.checked;
        input.disabled = original.disabled;
        const span = document.createElement('span');
        span.textContent = title === 'AVAILABILITY' ? 'IN STOCK' : original.value.toUpperCase();
        label.append(input, span);
        options.append(label);
      });
    });
    if ([...params.keys()].some(key => key.startsWith('filter.'))) {
      const clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'adwoa-filter-dropdown__clear';
      clear.textContent = 'CLEAR';
      clear.addEventListener('click', () => {
        const next = new URLSearchParams(location.search);
        [...next.keys()].forEach(key => { if (key.startsWith('filter.')) next.delete(key); });
        go(next);
      });
      form.append(clear);
    }
    form.addEventListener('submit', event => event.preventDefault());
    form.addEventListener('change', () => {
      const next = new URLSearchParams(location.search);
      managed.forEach(name => next.delete(name));
      new FormData(form).forEach((value, key) => next.append(key, String(value)));
      go(next);
    });
    panel.replaceChildren(form);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-adwoa-filter]');
    if (button && desktop.matches) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (trigger === button && panel && !panel.hidden) { close(); return; }
      close();
      trigger = button;
      trigger.classList.add('adwoa-filter-menu__trigger');
      trigger.setAttribute('aria-controls', 'AdwoaDesktopFilter');
      if (!panel) {
        panel = document.createElement('div');
        panel.id = 'AdwoaDesktopFilter';
        panel.className = 'adwoa-filter-dropdown';
        panel.setAttribute('aria-label', 'Product filters');
      }
      trigger.insertAdjacentElement('afterend', panel);
      build();
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      position();
      return;
    }
    if (panel && !panel.contains(event.target)) close();
  }, true);
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && panel && !panel.hidden) close(true); });
  document.addEventListener('focusin', event => { if (panel && !panel.hidden && !panel.contains(event.target) && event.target !== trigger) close(); });
  addEventListener('resize', position);
  desktop.addEventListener('change', () => close());
})();
